import { render } from "./HeroComp.vue?vue&type=template&id=5de2ba19&scoped=true"
import script from "./HeroComp.vue?vue&type=script&lang=js"
export * from "./HeroComp.vue?vue&type=script&lang=js"

import "./HeroComp.vue?vue&type=style&index=0&id=5de2ba19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de2ba19"]])

export default __exports__